import { AuthApi } from './authApi';
import { AccountApi } from './accountApi';
import { CountryApi } from './countryApi';
import { StatusRegisterApi } from './statusRegisterApi';
import { CompanyTypeApi } from './companyTypeApi';
import { CompanyHistoricalApi } from './companyHistoricalApi';
import { CompanyApi } from './companyApi';
import { StateApi } from './stateApi';
import { ContactApi } from './contactApi';
import { AddressApi } from './addressApi';
import { TranslateApi } from './translateApi';
import { SupplierTypeApi } from './supplierTypeApi';
import { SupplierCategoryApi } from './supplierCategoryApi';
import { UserGroupApi } from './userGroupApi';
import { CultureApi } from './cultureApi';
import { TimeZoneApi } from './timeZoneApi';
import { ScreensApi } from './screensApi';
import { YearApi } from './vehicle/yearApi';
import { ManufacturerApi } from './vehicle/manufacturerApi';
import { ModelApi } from './vehicle/modelApi';
import { SubModelApi } from './vehicle/subModelApi';
import { VehicleApi } from './vehicleApi';
import { ParameterApi } from './parameterApi';
import { DamageAreaApi } from './damageAreaApi';
import { AcceptanceTermsApi } from './acceptanceTermsApi';
import { FileImportApi } from './fileImportApi';
import { ControlApi } from './controlsApi';
import { PublicAddressIpApi } from './publicAddressIpApi';
import { ScreenApi } from './screenApi';
import { ClaimTypeApi } from './claimTypeApi';
import { PartApi } from './partApi';
import { UserPreferencesApi } from './userPreferencesApi';
import { InvoiceApi } from './invoiceApi';
import { QuoteHistoricalApi } from './quoteHistoricalApi';
import { IntegrationTriggerApi } from './integrationTriggerApi';
import { IntegrationIntegrationInterfaceCompanyApi } from './integrationIntegrationInterfaceCompanyApi';
import { SupplierApi } from './registration/supplierApi';
import { BodyshopApi } from './registration/bodyshopApi';
import { InsurerApi } from './registration/insurerApi';
import { UserApi } from './registration/userApi';
import { UsergroupApi } from './registration/usergroupApi';
import { ContactTypeApi } from './contactTypeApi';
import { MunicipalityApi } from './municipalityApi';
import { CityApi } from './cityApi';
import { AddressTypeApi } from './addressTypeApi';
import { DistributionRegionApi } from './distributionRegionApi';
import { ReasonApi } from './reasonApi';
import { SupplyConfigurationApi } from './supplyConfigurationApi';
import { PartTypeApi } from './partTypeApi';
import { CompanyBusinessHourApi } from './registration/companyBusinessHourApi';
import { PurchaseCriteriaApi } from './registration/purchaseCriteriaApi';
import { BrandApi } from './brandApi';
import { PackageApi } from './packageApi';
import { PartCatalogApi } from './registration/partCatalogApi';
import { QuoteApi } from './quoteApi';
import { CategoryApi } from './categoryApi';
import { OrderApi } from './order/orderApi';
import { ProcurementApi } from './procurementApi';
import { ProcurementParameterAuditApi } from './procurementParameterAuditApi';
import { WarehouseApi } from './warehouseApi';
import { PackingTrackingHistoryApi } from './packingTrackingHistoryApi';
import { QuoteImportStatusApi } from './order/quoteImportStatus';
import { QuoteSupplierItemStatusApi } from './quoteSupplierItemStatusApi';
import { QuoteSupplierItemApi } from './quotation/quoteSupplierItemApi';
import { SupplierInventoryApi } from './supplierInventoryApi';
import { SupplierInventoryImportApi } from './supplierInventoryImportApi';
import { SupplierInventoryImportStatusApi } from './supplierInventoryImportStatusApi';
import { SupplierInventoryWarehouseStatusApi } from './supplierInventoryWarehouseStatusApi';
import { SubcategoryApi } from './subcategoryApi';
import { PositionApi } from './partPositionApi';
import { ProcurementHistoricalApi } from './procurementHistoricalApi';
import { SupplierInventoryHistoryApi } from './supplierInventoryHistoryApi';
import { QuoteImportApi } from './order/quoteImport';
import { IntegrationApi } from './integrationApi';
import { IntegrationQueueApi } from './integrationQueueApi';
import { ProcurementReportApi } from './report/procurementReportApi';
import { IntegrationInterfaceCompanyApi } from './integration/integrationInterfaceCompanyApi';
import { IntegrationCodeApi } from './integrationCodeApi';
import { IntegrationLogApi } from './integrationLogApi';
import { AssessmentTypeApi } from './assessmentTypeApi';
import { ShippingCompanyApi } from './shippingCompanyApi';
import { PrioritySupplierApi } from './registration/prioritySupplierApi';
import { QuoteItemApi } from './quoteItemApi';
import { ClaimApi } from './claimApi';
import { PackingTrackingApi } from './order/packingTrackingApi';
import { HolidaysApi } from './registration/holidaysApi';
import { WhatsappApi } from './externalServices/whatsappApi';
import { CountryInfoApi } from './countryInfoApi';
import { EvaluationCompanyBuyerApi } from './evaluationCompanyBuyerApi';
import { CacheApi } from './public/cacheAPI';
import { ReCAPTCHAApi } from './externalServices/reCAPTCHAApi';
import { RegistrationPublicApi } from './public/registrationPublicAPI';
import { HomePagePublicApi } from './public/homePagePublicApi';
import { StripeApi } from './integration/stripeApi';
import { ProcurementReportScheduleStatusAPI } from './report/procurementReportScheduleStatusApi';
import { ProcurementReportScheduleAPI } from './report/procurementReportScheduleApi';
import { UserTypeApi } from './registration/userTypeApi';
import { DeliveryTypeApi } from './deliveryTypeApi';
import { PartTypePerPartApi } from './registration/partTypePerPartApi';
import { VariableTypeApi } from './variableTypeApi';
import { QuoteItemCommentApi } from './quoteItemCommentApi';
import { ReportTemplateApi } from './registration/reportTemplateApi';
import { ReportTemplateTypeApi } from './registration/reportTemplateTypeApi';
import { ReportTemplateHistoricalApi } from './reportTemplateHistoricalApi';
import { SystemApplicationApi } from './systemApplicationApi';
import { SystemGuideApi } from '@/main/api/systemGuideApi';
import { ValuatorApi } from './registration/valuatorApi';
import { SupervisorApi } from './supervisorApi';
import { UserHierarchyApi } from './userHierarchyApi';
import { InsuranceSublineApi } from './insuranceSublineApi';
import { DamageCategoryApi } from './registration/damageCategoryApi';
import { DamageSubCategoryApi } from './damageSubCategoryApi';
import { CompanyManufacturerApi } from './registration/companyManufacturerApi';
import { BodyshopTypeApi } from './bodyshopTypeApi';
import { EntityTypeApi } from './entityTypeApi';
import { RateApi } from './rateApi';
import { AffectedTypeApi } from './registration/affectedTypeApi';
import { ClaimFileCategoryApi } from './claimFileCategoryApi';
import { IntegrationPropertyFilterApi } from './integrationPropertyFilterApi';
import { UserPreferencesFavoriteSearchApi } from './userPreferencesFavoriteSearchApi';
import { CompanyPreferenceApi } from './companyPreferenceApi';
import { TemplateEmailNotificationApi } from './templateEmailNotificationApi';
import { TemplateEmailNotificationCompanyApi } from './templateEmailNotificationCompanyApi';
import { AnnouncementApi } from './announcementApi';
import { DirectAssignCriteriaApi } from './registration/directAssignCriteriaApi';
import { QuoteImageApi } from '@/main/api/quoteImageApi';
import { PartBrandApi } from '@/main/api/registration/partBrandApi';
import { FavoriteCategoryApi } from '@/main/api/favoriteCategoryApi';
import { FileTypeApi } from '@/main/api/fileTypeApi';
import { HierarchyLevelApi } from '@/main/api/hierarchyLevelApi';
import { RateImportStatusApi } from './rateImportStatusApi';
import { RateImportApi } from './rateImportApi';
import { ApprovalMatrixApi } from '@/main/api/registration/approvalMatrixApi';
import { ApprovalMatrixTypeApi } from '@/main/api/approvalMatrixTypeApi';
import { ApprovalMatrixHistoricalApi } from '@/main/api/registration/approvalMatrixHistoricalApi';
import { EmailTemplateVariablesApi } from './registration/emailTemplateVariablesApi';
import { TemplateEmailNotificationVariableApi } from './templateEmailNotificationVariableApi';
import { TemplateEmailNotificationHistoricalApi } from './templateEmailNotificationHistoricalApi';

export const authApi = new AuthApi();
export const accountApi = new AccountApi();
export const countryApi = new CountryApi();
export const statusRegisterApi = new StatusRegisterApi();
export const companyTypeApi = new CompanyTypeApi();
export const companyHistoricalApi = new CompanyHistoricalApi();
export const companyApi = new CompanyApi();
export const bodyshopApi = new BodyshopApi();
export const insurerApi = new InsurerApi();
export const usergroupApi = new UsergroupApi();
export const screenApi = new ScreenApi();
export const controlApi = new ControlApi();
export const contactApi = new ContactApi();
export const addressApi = new AddressApi();
export const supplierApi = new SupplierApi();
export const stateApi = new StateApi();
export const translateApi = new TranslateApi();
export const userApi = new UserApi();
export const userGroupApi = new UserGroupApi();
export const cultureApi = new CultureApi();
export const timeZoneApi = new TimeZoneApi();
export const screensApi = new ScreensApi();
export const contactTypeApi = new ContactTypeApi();
export const municipalityApi = new MunicipalityApi();
export const cityApi = new CityApi();
export const addressTypeApi = new AddressTypeApi();
export const distributionRegionApi = new DistributionRegionApi();
export const supplierTypeApi = new SupplierTypeApi();
export const supplierCategoryApi = new SupplierCategoryApi();
export const reasonApi = new ReasonApi();
export const supplyConfigurationApi = new SupplyConfigurationApi();
export const partTypeApi = new PartTypeApi();
export const categoryApi = new CategoryApi();
export const orderApi = new OrderApi();
export const yearApi = new YearApi();
export const manufacturerApi = new ManufacturerApi();
export const modelApi = new ModelApi();
export const subModelApi = new SubModelApi();
export const vehicleApi = new VehicleApi();
export const quoteApi = new QuoteApi();
export const parameterApi = new ParameterApi();
export const damageAreaApi = new DamageAreaApi();
export const acceptanceTermsApi = new AcceptanceTermsApi();
export const fileImportApi = new FileImportApi();
export const procurementApi = new ProcurementApi();
export const publicAddressIpApi = new PublicAddressIpApi();
export const claimTypeApi = new ClaimTypeApi();
export const companyBusinessHourApi = new CompanyBusinessHourApi();
export const partApi = new PartApi();
export const purchaseCriteriaApi = new PurchaseCriteriaApi();
export const userPreferencesApi = new UserPreferencesApi();
export const quoteSupplierItemStatusApi = new QuoteSupplierItemStatusApi();
export const warehouseApi = new WarehouseApi();
export const brandApi = new BrandApi();
export const packageApi = new PackageApi();
export const quoteSupplierItemApi = new QuoteSupplierItemApi();
export const supplierInventoryApi = new SupplierInventoryApi();
export const supplierInventoryImportApi = new SupplierInventoryImportApi();
export const supplierInventoryImportStatusApi =
  new SupplierInventoryImportStatusApi();
export const supplierInventoryWarehouseStatusApi =
  new SupplierInventoryWarehouseStatusApi();
export const subcategoryApi = new SubcategoryApi();
export const positionApi = new PositionApi();
export const packingTrackingHistoryApi = new PackingTrackingHistoryApi();
export const supplierInventoryHistoryApi = new SupplierInventoryHistoryApi();
export const invoiceApi = new InvoiceApi();
export const quoteHistoricalApi = new QuoteHistoricalApi();
export const procurementHistoricalapi = new ProcurementHistoricalApi();
export const partCatalogApi = new PartCatalogApi();
export const quoteImportStatusApi = new QuoteImportStatusApi();
export const quoteImportApi = new QuoteImportApi();
export const integrationTriggerApi = new IntegrationTriggerApi();
export const integrationIntegrationInterfaceCompanyApi =
  new IntegrationIntegrationInterfaceCompanyApi();
export const integrationApi = new IntegrationApi();
export const integrationQueueApi = new IntegrationQueueApi();
export const procurementParameterAuditApi = new ProcurementParameterAuditApi();
export const procurementReportApi = new ProcurementReportApi();
export const integrationInterfaceCompanyApi =
  new IntegrationInterfaceCompanyApi();
export const integrationCodeApi = new IntegrationCodeApi();
export const integrationLogApi = new IntegrationLogApi();
export const assessmentTypeApi = new AssessmentTypeApi();
export const shippingCompanyApi = new ShippingCompanyApi();
export const prioritySupplierApi = new PrioritySupplierApi();
export const quoteItemApi = new QuoteItemApi();
export const claimApi = new ClaimApi();
export const packingTrackingApi = new PackingTrackingApi();
export const holidaysApi = new HolidaysApi();
export const whatsappApi = new WhatsappApi();
export const countryInfoApi = new CountryInfoApi();
export const evaluationCompanyBuyerApi = new EvaluationCompanyBuyerApi();
export const cacheApi = new CacheApi();
export const recaptchaAPI = new ReCAPTCHAApi();
export const registrationPublicApi = new RegistrationPublicApi();
export const homePagePublicApi = new HomePagePublicApi();
export const stripeApi = new StripeApi();
export const procurementReportScheduleStatusApi =
  new ProcurementReportScheduleStatusAPI();
export const procurementReportScheduleApi = new ProcurementReportScheduleAPI();
export const userTypeApi = new UserTypeApi();
export const deliveryTypeApi = new DeliveryTypeApi();
export const partTypePerPartApi = new PartTypePerPartApi();
export const variableTypeApi = new VariableTypeApi();
export const quoteItemCommentApi = new QuoteItemCommentApi();
export const reportTemplateApi = new ReportTemplateApi();
export const reportTemplateTypeApi = new ReportTemplateTypeApi();
export const reportTemplateHistoricalApi = new ReportTemplateHistoricalApi();
export const systemApplicationApi = new SystemApplicationApi();
export const systemGuideApi = new SystemGuideApi();
export const valuatorApi = new ValuatorApi();
export const supervisorApi = new SupervisorApi();
export const userHierarchyApi = new UserHierarchyApi();
export const insuranceSublineApi = new InsuranceSublineApi();
export const damageCategoryApi = new DamageCategoryApi();
export const damageSubCategoryApi = new DamageSubCategoryApi();
export const companyManufacturerApi = new CompanyManufacturerApi();
export const bodyshopTypeApi = new BodyshopTypeApi();
export const entityTypeApi = new EntityTypeApi();
export const rateApi = new RateApi();
export const affectedTypeApi = new AffectedTypeApi();
export const claimFileCategoryApi = new ClaimFileCategoryApi();
export const integrationPropertyFilterApi = new IntegrationPropertyFilterApi();
export const userPreferencesFavoriteSearchApi =
  new UserPreferencesFavoriteSearchApi();
export const companyPreferenceApi = new CompanyPreferenceApi();
export const templateEmailNotificationApi = new TemplateEmailNotificationApi();
export const templateEmailNotificationCompanyApi =
  new TemplateEmailNotificationCompanyApi();
export const announcementApi = new AnnouncementApi();
export const directAssignCriteriaApi = new DirectAssignCriteriaApi();
export const quoteImageApi = new QuoteImageApi();
export const partBrandApi = new PartBrandApi();
export const favoriteCategoryApi = new FavoriteCategoryApi();
export const fileTypeApi = new FileTypeApi();
export const hierarchyLevelApi = new HierarchyLevelApi();
export const rateImportStatusApi = new RateImportStatusApi();
export const rateImportApi = new RateImportApi();
export const approvalMatrixApi = new ApprovalMatrixApi();
export const approvalMatrixTypeApi = new ApprovalMatrixTypeApi();
export const approvalMatrixHistoricalApi = new ApprovalMatrixHistoricalApi();
export const emailTemplateVariablesApi = new EmailTemplateVariablesApi();
export const templateEmailNotificationVariableApi = new TemplateEmailNotificationVariableApi();
export const templateEmailNotificationHistoricalApi = new TemplateEmailNotificationHistoricalApi();
